// Centralized date-fns locale imports for ESM compatibility
import { type Locale } from 'date-fns';
import { da } from 'date-fns/locale/da';
import { de } from 'date-fns/locale/de';
import { enAU } from 'date-fns/locale/en-AU';
import { enCA } from 'date-fns/locale/en-CA';
import { enGB } from 'date-fns/locale/en-GB';
import { enIN } from 'date-fns/locale/en-IN';
import { enNZ } from 'date-fns/locale/en-NZ';
import { enUS } from 'date-fns/locale/en-US';
import { enZA } from 'date-fns/locale/en-ZA';
import { es } from 'date-fns/locale/es';
import { fr } from 'date-fns/locale/fr';
import { it } from 'date-fns/locale/it';
import { nl } from 'date-fns/locale/nl';
import { pt } from 'date-fns/locale/pt';
import { ptBR } from 'date-fns/locale/pt-BR';
import { sv } from 'date-fns/locale/sv';

export const locales: Record<string, Locale> = {
  da,
  de,
  enAU,
  enCA,
  enGB,
  enIN,
  enNZ,
  enUS,
  enZA,
  es,
  fr,
  it,
  nl,
  pt,
  ptBR,
  sv,
};
